import {
  CompanyCampaignExistingCustomerPageQuery,
  CompanyCampaignExistingCustomerPageRecord,
  CompanyCampaignPageQuery,
  CompanyCampaignPageRecord
} from '~/config/generated/graphql';

const handleCMSData = (
  cmsData: CompanyCampaignPageRecord | CompanyCampaignExistingCustomerPageRecord
) => {
  return {
    kvdHelperUrl: cmsData?._editingUrl,
    hero: cmsData?.hero,
    heroForm: {
      title: cmsData?.heroFormTitle,
      btnText: cmsData?.heroFormBtnText
    },
    contactForm: {
      sectionTitle: cmsData?.contactFormSectionTitle,
      sectionDescription: cmsData?.contactFormSectionDescription,
      title: cmsData?.contactFormTitle,
      newsletterLabel: cmsData?.contactFormNewsletterLabel,
      btnText: cmsData?.contactFormBtnText,
      success: cmsData?.contactFormSuccess
    },
    fleetValComp: {
      title: cmsData?.fleetValCompTitle,
      averageProfitPerCar: cmsData?.fleetValCompAverageProfitPerCar as number,
      averageValuationDescription:
        cmsData?.fleetValCompAverageValuationDescription,
      kvdAverageValuation: cmsData?.fleetValCompKvdAverageValuation as number,
      dealerAverageValuation:
        cmsData?.fleetValCompDealerAverageValuation as number,
      disclaimer: cmsData?.fleetValCompDisclaimer,
      totalVehiclesInfo: cmsData?.fleetValCompTotalVehiclesInfo,
      kvdValuationTitle: cmsData?.fleetValCompKvdValuationTitle,
      kvdValuationDescription: cmsData?.fleetValCompKvdValuationDescription,
      dealerValuationTitle: cmsData?.fleetValCompDealerValuationTitle,
      dealerValuationDescription:
        cmsData?.fleetValCompDealerValuationDescription,
      resultTitle: cmsData?.fleetValCompResultTitle,
      resultDescription: cmsData?.fleetValCompResultDescription
    },
    modularSections: cmsData?.modularSections,
    seo: cmsData?.seo
  };
};

export const handleCompanyCampaignExistingCustomerPage = ({
  companyCampaignExistingCustomerPage
}: CompanyCampaignExistingCustomerPageQuery) => {
  return handleCMSData(
    companyCampaignExistingCustomerPage as CompanyCampaignExistingCustomerPageRecord
  );
};

export const handleCompanyCampaignPage = ({
  companyCampaignPage
}: CompanyCampaignPageQuery) => {
  return handleCMSData(companyCampaignPage as CompanyCampaignPageRecord);
};
